import React from 'react';

// Components
import Hero from './Hero';
import About from './About';
import Projects from './Projects';
import Blog from './Blog';
import Contact from './Contact';
import Footer from './Footer';

// Data
import { personalInfo, aboutMe, skills } from '../data/personal';
import { projects } from '../data/projects';

const HomePage: React.FC = () => {
  return (
    <>
      <Hero personalInfo={personalInfo} />
      <About aboutParagraphs={aboutMe.paragraphs} skills={skills} />
      <Projects projects={projects} />
      <Blog />
      <Contact personalInfo={personalInfo} />
      <Footer name={personalInfo.name} />
    </>
  );
};

export default HomePage;
